import PropTypes                                      from 'prop-types';
import React, {useState} from 'react';
import { useTranslation }                             from 'react-i18next';
import FormGroup                                      from '@material-ui/core/FormGroup';
import FormControlLabel                               from '@material-ui/core/FormControlLabel';
import Checkbox                                       from '@material-ui/core/Checkbox';
import { Grid }                                       from '@material-ui/core';
import { useUserOTPSetAction, useUserOTPUnsetAction } from '@karpeleslab/klb-react-services';
import RequestOtpDialog from '../RequestOtpDialog';

const ACTIONS = ['login'];

const OtpActions = ({ otp, refresh }) => {
	const { t } = useTranslation();
	const [set, setting] = useUserOTPSetAction(otp.User_Otp__);
	const [unset, unsetting] = useUserOTPUnsetAction(otp.User_Otp__);
	const [showOtpDialog, setShowOtpDialog] = useState(false);
	const [otpCallback, setOtpCallback] = useState();

	const setHandler = action => {
		set(action).then(refresh);
	};

	const unsetHandler = (action, extra = {}) => {
		unset(action, extra)
			.then(refresh)
			.catch(e => {
				if(e.token === 'error_otp_required') {
					setOtpCallback(() => {
						return (inputOtp) => {
							unsetHandler(action,{extraParams : {otp_response:inputOtp, otp_session:e.otp_session}});
						};
					});
					setShowOtpDialog(true);
				}
			});
	};

	const isActivated = action => {
		return (otp.Actions ?? []).includes(action);
	};

	const createChangeHandler = action => e => {
		if (e.target.checked) setHandler(action);
		else unsetHandler(action);
	};

	return (
		<FormGroup>
			<Grid container spacing={3}>
				{ACTIONS.map(a =>
					<Grid item key={`opt_action_${a}`}>
						<FormControlLabel
							control={<Checkbox
								color='primary'
								disabled={setting || unsetting}
								checked={isActivated(a)}
								onChange={createChangeHandler(a)}
								name={a}/>
							}
							label={t(`opt_action_${a}`)}
						/>
					</Grid>
				)}
			</Grid>
			{showOtpDialog &&
				<RequestOtpDialog
					open={showOtpDialog}
					setOpen={setShowOtpDialog}
					closeCallback={otpCallback}
				/>
			}
		</FormGroup>
	);
};

export default OtpActions;

OtpActions.propTypes = {
	otp: PropTypes.object,
	refresh: PropTypes.func.isRequired
};
